import { Status } from './status.model';
import { Company } from './company.model';
import { StoryContact } from './story-contact.model';
import { StoryLink } from './story-link.model';
import { StorySubject } from './story-subject.model';
import { BodyContentsModel } from './body-content-model';
import { Injectable } from '@angular/core';

@Injectable()
export class UnifiedStoryRequestModel {
    name?: string;
    headline?: string;
    body?: string;
    author?: string;
    publishedDate?: number;
    timeZone?: string;
    imageId?: string;
    imageData?: string;
    aboutUs?: string;
    status?: Status;
    links?: StoryLink[];
    company?: Company;
    subjects?: StorySubject[];
    contacts?: StoryContact[];
    bodyContents?: BodyContentsModel[];
    datelineDate?: number;
    datelineLocation?: string;
}
